

// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rhejhesgzmeeewsweupk.supabase.co'; // Replace with your Supabase URL
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJoZWpoZXNnem1lZWV3c3dldXBrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzA4ODMxNjMsImV4cCI6MjA0NjQ1OTE2M30.NBP4lzhzw0C0Gt0B-n_ACo0kQFUPEMR7DclVOfe05w0'; // Replace with your Supabase anon key

export const supabase = createClient(supabaseUrl, supabaseKey);


